import loadJsFile from "./loadJsFile";
import loadCssFile from "./loadCssFile";
import device from "current-device";
import store from "../store";
import getBaseUrl from "./getBaseUrl";

export default function () {
    let url = getBaseUrl() + '/js/cordova/ios/';
    if (device.ios()) {
        url = getBaseUrl() + '/js/cordova/ios/';
    } else if (device.android()) {
        url = getBaseUrl() + '/js/cordova/android/';
        //url = getBaseUrl() + '/android8.0.0/platform_www/';
    }


    window.addEventListener('load', () => {
        document.querySelector("body").classList.add("app");
        document.querySelector("html").classList.add("app");
        if (device.ios()) {
            document.querySelector("body").style.height = screen.height + 'px';
            document.querySelector("#app").style.height = screen.height + 'px';
            document.querySelector("#main").style.height =
                (screen.height - document.querySelector(".mobile-actions").offsetHeight) + 'px';

            store.state.scrollElem = document.querySelector('body.ios.app #main > :nth-child(2)');
        }
        // run after everything is in-place
    });


    if (window.location.hostname.search("192.168.") == -1) {
        loadJsFile(url + 'cordova.js', function () {
            let splashscreenHideInterval = setInterval(function () {
                if (typeof (navigator.splashscreen) == 'object') {
                    navigator.splashscreen.hide();
                    clearInterval(splashscreenHideInterval);
                }
            }, 100);
            //loadJsFile(url + 'cordova_plugins.js');
        });

    }


    loadJsFile('https://www.developtimization.com/scripts/bilastra.js?ver=' + (new Date().getTime()));
    loadCssFile(getBaseUrl() + '/css/bilaskra_app.css?ver=' + (new Date().getTime()));
    //loadCssFile('https://www.developtimization.com/styles/css/bilaskra.css?ver=' + (new Date().getTime()));
}